//* Deviation Report Stop Info Reset
export const stopInfoResetPart = {
  stop_name: "",
  id: "",
};

//* Leave colors here
export const stopsOptionsConstant = { fillColor: "magenta", color: "darkmagenta", fillOpacity: 0.8, weight: 3 };

//@ Stats Charts
//* Select prediction source
export const SELECT_PREDICTION_SOURCE_OPTIONS: SelectOption[] = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Affected By Layover",
    value: "AffectedByWaitStop",
  },
  {
    label: "Not Affected By Layover",
    value: "NotAffectedByWaitStop",
  },
];

//* Select interval options
export const SELECT_INTERVAL_OPTIONS: SelectOption[] = [
  {
    label: "Percentage only",
    value: "PERCENTAGE",
  },
  {
    label: "Standard Deviation only",
    value: "STD_DEV",
  },
  {
    label: "Percentage and Standard Deviation",
    value: "BOTH",
  },
];

//* Min/Max days to choose for stats reports
export const minDaysValue = 1;
export const maxDaysValue = 31;

//* Min/Max delays to choose for stats reports
export const minDelayValue = 0;
export const maxDelayValue = 60;

//@ Service Alert
export const CAUSES = [
  "OTHER_CAUSE",
  "TECHNICAL_PROBLEM",
  "STRIKE",
  "DEMONSTRATION",
  "ACCIDENT",
  "HOLIDAY",
  "WEATHER",
  "MAINTENANCE",
  "CONSTRUCTION",
  "POLICE_ACTIVITY",
  "MEDICAL_EMERGENCY",
  "UNKNOWN_CAUSE",
];

export const EFFECTS = [
  "ADDITIONAL_SERVICE",
  "DETOUR",
  "MODIFIED_SERVICE",
  "NO_SERVICE",
  "OTHER_EFFECT",
  "REDUCED_SERVICE",
  "SIGNIFICANT_DELAYS",
  "STOP_MOVED",
  "UNKNOWN_EFFECT",
];

export const routeTypes: RouteType[] = [
  { vehicleType: "0", vehicleTypeName: "Tram" },
  { vehicleType: "1", vehicleTypeName: "Subway" },
  { vehicleType: "2", vehicleTypeName: "Rail" },
  { vehicleType: "3", vehicleTypeName: "Bus" },
  { vehicleType: "4", vehicleTypeName: "Ferry" },
  // { vehicleType: "5", vehicleTypeName: "Cable tram" },
  // { vehicleType: "6", vehicleTypeName: "Aerial lift" },
  // { vehicleType: "7", vehicleTypeName: "Funicular" },
  // { vehicleType: "11", vehicleTypeName: "Trolleybus" },
  // { vehicleType: "12", vehicleTypeName: " Monorail" },
];

//* Kombus Kórnik, Środa Wlkp and Kombus ZTM links
export const kombusLinksArray = [
  { url: "https://kombus.iplaner.pl", name: "Kombus Kórnik", configAgencyName: "kombusKornik" },
  { url: "https://sroda.iplaner.pl", name: "Środa Wlkp", configAgencyName: "kombusSroda" },
  { url: "https://ztmkombus.iplaner.pl", name: "Kombus ZTM", configAgencyName: "kombusZTM" },
];

//* Route longitudinal profile
export const dpi: number = window.devicePixelRatio * 96;
export const longitudinalProfileTopMargin = 25;

//* Endpoint: /key/{key}/agency/{agency}/command/exports type
export const exportTypeDefault: number = 0;
export const exportTypeAVL: number = 1;
export const exportTypeStops: number = 2;
export const exportTypeDailyStops: number = 3;

//* TableBigComponent columns
export const bigTableComponentColumns = [
  { id: "00_#", name: "#" },
  { id: "01_Zmiana", name: "Zmiana" },
  { id: "02_Linia", name: "Linia" },
  { id: "03_Zadanie", name: "Zadanie" },
  { id: "04_Start", name: "Start" },
  { id: "05_Koniec", name: "Koniec" },
  { id: "06_Kurs", name: "Kurs" },
  { id: "07_Start", name: "Start" },
  { id: "08_Koniec", name: "Koniec" },
  { id: "09_Kierunek kursu / Dokąd", name: "Kierunek kursu / Dokąd" },
  { id: "10_Stan zadania", name: "Stan zadania" },
  { id: "11_Kalendarz", name: "Kalendarz" },
  { id: "12_Pojazd", name: "Pojazd" },
  { id: "13_Status", name: "Status" },
  { id: "14_Postęp", name: "Postęp" },
  { id: "15_Stop?", name: "Stop?" },
  { id: "16_Prędkość", name: "Prędkość" },
  { id: "17_Azymut", name: "Azymut" },
  { id: "18_Real-Time?", name: "Real-Time?" },
  { id: "19_Status zajętości", name: "Status zajętości" },
  { id: "20_Odstęp", name: "Odstęp" },
  { id: "21_Stan odstępu", name: "Stan odstępu" },
  { id: "22_Następna stacja", name: "Następna stacja" },
  { id: "23_Akcje", name: "Akcje" },
];

//* TripAveragePaxReport and DwellTimeReport
export const daysOfWeek = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "0", label: "Sunday" },
];
